<template>

    <div class="galaxy::common-canvas-editor-VersionActions tw-ml-auto tw-flex tw-items-center">

        <h6 class="card-subtitle tw-my-0" style="margin-bottom: 0 !important">{{ useVersioning ? 'Wijzigingen worden niet direct live geplaatst.' : 'Omdat je lokaal werkt worden wijzigingen direct bewaard' }}</h6>

        <div :class="{
            'opacity-25': !useVersioning,
            'pointer-events-none': !useVersioning
        }">

            <button
                    v-if="conceptRevertable"
                    class="tw-bg-transparent tw-border-0 text-info tw-text-sm tw-mx-3"
                    :disabled="versionState == 'live'"
                    @click="resetCanvasVersion">
                <u>Wijzigingen verwijderen</u></button>

            <button
                    v-if="useVersioning"
                    class="btn btn-success"
                    :class="{ 'tw-ml-4': !conceptRevertable }"
                    :disabled="versionState == 'live'"
                    @click="activateCanvasVersion">Live plaatsen</button>

        </div>

    </div>

</template>

<script>

    import Swal from 'sweetalert2';
    import axios from '@galaxy/js/common/AxiosBuilder';

    export default {

        props: {
            canvasVersion: Object,
            versionState: String,
            useVersioning: Boolean,
            currentLanguage: String,
        },

        data()
        {
            return {
            };
        },

        methods: {

            async resetCanvasVersion()
            {
                // Abort due to user does not confirm?
                const { value: confirmed } = await Swal.fire({
                    title: 'Weet u het zeker?',
                    text: 'Weet u zeker dat u alle wijzigingen wilt verwijderen? U keert dan terug naar de live versie.',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Ja, verwijder',
                    confirmButtonColor: '#f62d51',
                    cancelButtonText: 'Annuleer',
                });

                if(!confirmed)
                    return;

                // Send to server.
                let response = await axios.post('/admin/canvas-editor/' + this.canvasVersion.id + '/reset');

                // @ugly TODO High: Implement below.
                document.location.reload(true);

                /*
                // Emit update.
                this.$emit('update:canvasVersion', response.data.canvasVersions[this.currentLanguage]);
                this.$emit('canvasVersionBackToLive');

                // Show toast.
                this.$toasted.show('<i class="fas fa-history"></i> Versie gereset naar live.', {
                    duration: 3000,
                    type: 'info',
                    iconPack: 'fontawesome',
                });
                */
            },

            async activateCanvasVersion()
            {
                // Abort due to user does not confirm?
                const { value: confirmed } = await Swal.fire({
                    title: 'Weet u het zeker?',
                    text: 'Weet u zeker dat u deze versie live wilt plaatsen? Bezoekers zien dan de laatste aanpassingen.',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Ja, live plaatsen',
                    confirmButtonColor: '#62de43',
                    cancelButtonText: 'Annuleer',
                });

                if(!confirmed)
                    return;

                // Send to server.
                let response = await axios.post('/admin/canvas-editor/' + this.canvasVersion.id + '/activate');

                // Emit update.
                this.$emit('onNewCanvasVersions', response.data.canvasVersions);
                this.$emit('canvasVersionBackToLive');

                // Show toast.
                this.$toasted.show('<i class="far fa-globe"></i> Versie live geplaatst!', {
                    duration: 3000,
                    type: 'success',
                    iconPack: 'fontawesome',
                });
            },

        },

        computed: {

            conceptRevertable()
            {
                return this.canvasVersion.created_at != this.canvasVersion.update_at ? true : false;
            },

        },

    }

</script>

<style lang="scss" scoped>

    .galaxy\:\:common-canvas-editor-VersionActions {

        button {
            cursor: pointer;
            outline: none !important;

            &[disabled] {
                opacity: .65;
            }

        }

    }

</style>
